export const environment = {
    production: false,        
    managerURL: 'https://dev.sisdio-manager-service.novacap.i9partner.com.br/api',
    relatoriosURL: 'https://dev.sisdio-relatorio.novacap.i9partner.com.br/api',
    workersURL: 'http://localhost:3000/api',
    keycloakURL: 'https://keycloak.tools.i9partner.com.br/realms/Sisdio-dev',
    elasticMsURL: 'https://dev.sisdio-elastic-ms.novacap.i9partner.com.br/api',
    apmServiceUrl: 'https://1c37c0ba3f67402a83cc12d6ef8b95f0.apm.us-east1.gcp.elastic-cloud.com:443',
    googleMapsApiKey: 'AIzaSyBoA55tE_o5BwJTReXtMx8hZJqlC0yfGP8',
    googleMapsMapId: 'DEMO_MAP_ID' 
};
